export default "__VITE_ASSET__BF7h2m8g__"